// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".story-bg[data-v-cc7e2a3c]{background-size:cover!important;background-position:50%!important}", ""]);
// Exports
module.exports = exports;
